import { LEAD_DETAILS_FORM_UPDATED, FORM_CLEARED } from '../core/action-types'

export const updateForm = (form) => {
  return { type: LEAD_DETAILS_FORM_UPDATED, payload: form }
}

export const unloadForms = () => {
  return { type: FORM_CLEARED }
}
